export const DosageOptions = [
    { value: 'tablets', label: 'TABLETS' },
    { value: 'capsules', label: 'CAPSULES' },
    { value: 'chewable tablets', label: 'CHEWABLE TABLETS' },
    { value: 'powders', label: 'POWDERS' },
    { value: 'solutions', label: 'SOLUTIONS' },
    { value: 'emulsions', label: 'EMULSIONS' },
    { value: 'suspensions', label: 'SUSPENSIONS' },
    { value: 'lotions', label: 'LOTIONS' },
    { value: 'creams', label: 'CREAMS' },
    { value: 'ointments', label: 'OINTMENTS' },
    { value: 'effervescent granules', label: 'EFFERVESCENT GRANULES' },
    { value: 'aerosols', label: 'AEROSOLS' },
    { value: 'gases', label: 'GASES' },
    { value: 'suppositories', label: 'SUPPOSITORIES' },
    { value: 'injections', label: 'INJECTIONS' }
]

export const RouteOptions = [
    { value: 'oral', label: 'ORAL' },
    { value: 'topical_skin', label: 'TOPICAL SKIN' },
    { value: 'topical-eyes', label: 'TOPICAL EYE' },
    { value: 'topical_ears', label: 'TOPICAL EARS' },
    { value: 'inhalation', label: 'INHALATION' },
    { value: 'injections', label: 'INJECTIONS' },
    { value: 'vaginal', label: 'VAGINAL' },
    { value: 'anal', label: 'ANAL' },
    { value: 'sub_lingual', label: 'SUB LINGUAL' }
]

export const StrengthOptions = [
    { value: 'mg', label: 'mg' },
    { value: 'g', label: 'g' },
    { value: 'ml', label: 'mL' },
    { value: 'mcg', label: 'mcg' },
    { value: 'mEq', label: 'mEq' },
    { value: 'iu', label: 'IU' },
]

export const medicinclasses = [
    { value: 'drugs_for_acid_related_disorders', label: 'DRUGS FOR ACID RELATED DISORDERS' },
    { value: 'drugs_for_functional_gastrointestinal_disorders', label: 'DRUGS FOR FUNCTIONAL GASTROINTESTINAL DISORDERS' },
    { value: 'antiemetics_and_antinauseants', label: 'ANTIEMETICS AND ANTINAUSEANTS' },
    { value: 'bile_and_liver_therapy', label: 'BILE AND LIVER THERAPY' },
    { value: 'drugs_for_constipation', label: 'DRUGS FOR CONSTIPATION' },
    { value: 'antidiarrheals_intestinal_antiinflammatoryantiinfective_agents', label: 'ANTIDIARRHEALS, INTESTINAL ANTIINFLAMMATORY/ANTIINFECTIVE AGENTS' },
    { value: 'drugs_used_in_diabetes', label: 'DRUGS USED IN DIABETES' },
    { value: 'vitamins', label: 'VITAMINS' },
    { value: 'antithrombotic_agents', label: 'ANTITHROMBOTIC AGENTS' },
    { value: 'antihemorrhagics', label: 'ANTIHEMORRHAGICS' },
    { value: 'antianemic_preparations', label: 'ANTIANEMIC PREPARATIONS' },
    { value: 'blood_substitutes_and_perfusion_solutions', label: 'BLOOD SUBSTITUTES AND PERFUSION SOLUTIONS' },
    { value: 'cardiac_therapy', label: 'CARDIAC THERAPY' },
    { value: 'diuretics', label: 'DIURETICS' },
    { value: 'peripheral_vasodilators', label: 'PERIPHERAL VASODILATORS' },
    { value: 'vasoprotectives', label: 'VASOPROTECTIVES' },
    { value: 'beta_blocking_agents', label: 'BETA BLOCKING AGENTS' },
    { value: 'calcium_channel_blockers', label: 'CALCIUM CHANNEL BLOCKERS' },
    { value: 'agents_acting_on_the_renin-angiotensin_system', label: 'AGENTS ACTING ON THE RENIN-ANGIOTENSIN SYSTEM' },
    { value: 'lipid_modifying_agents', label: 'LIPID MODIFYING AGENTS' },
    { value: 'antipruritics_incl._antihistamines_anesthetics_etc.', label: 'ANTIPRURITICS, INCL. ANTIHISTAMINES, ANESTHETICS, ETC.' },
    { value: 'antipsoriatics', label: 'ANTIPSORIATICS' },
    { value: 'antibiotics_and_chemotherapeutics_for_dermatological_use', label: 'ANTIBIOTICS AND CHEMOTHERAPEUTICS FOR DERMATOLOGICAL USE' },
    { value: 'corticosteroids_dermatological_preparations', label: 'CORTICOSTEROIDS, DERMATOLOGICAL PREPARATIONS' },
    { value: 'antiseptics_and_disinfectants', label: 'ANTISEPTICS AND DISINFECTANTS' },
    { value: 'anti-acne_preparations', label: 'ANTI-ACNE PREPARATIONS' },
    { value: 'other_dermatological_preparations', label: 'OTHER DERMATOLOGICAL PREPARATIONS' },
    { value: 'gynecological_antiinfectives_and_antiseptics', label: 'GYNECOLOGICAL ANTIINFECTIVES AND ANTISEPTICS' },
    { value: 'other_gynecologicals', label: 'OTHER GYNECOLOGICALS' },
    { value: 'sex_hormones_and_modulators_of_the_genital_system', label: 'SEX HORMONES AND MODULATORS OF THE GENITAL SYSTEM' },
    { value: 'urologicals', label: 'UROLOGICALS' },
    { value: 'corticosteroids_for_systemic_use', label: 'CORTICOSTEROIDS FOR SYSTEMIC USE' },
    { value: 'antibacterials_for_systemic_use', label: 'ANTIBACTERIALS FOR SYSTEMIC USE' },
    { value: 'antimycotics_for_systemic_use', label: 'ANTIMYCOTICS FOR SYSTEMIC USE' },
    { value: 'antimycobacterials', label: 'ANTIMYCOBACTERIALS' },
    { value: 'antivirals_for_systemic_use', label: 'ANTIVIRALS FOR SYSTEMIC USE' },
    { value: 'vaccines', label: 'VACCINES' },
    { value: 'antineoplastic_agents', label: 'ANTINEOPLASTIC AGENTS' },
    { value: 'endocrine_therapy', label: 'ENDOCRINE THERAPY' },
    { value: 'antiinflammatory_and_antirheumatic_products', label: 'ANTIINFLAMMATORY AND ANTIRHEUMATIC PRODUCTS' },
    { value: 'muscle_relaxants', label: 'MUSCLE RELAXANTS' },
    { value: 'antigout_preparations', label: 'ANTIGOUT PREPARATIONS' },
    { value: 'drugs_for_treatment_of_bone_diseases', label: 'DRUGS FOR TREATMENT OF BONE DISEASES' },
    { value: 'anesthetics', label: 'ANESTHETICS' },
    { value: 'analgesics', label: 'ANALGESICS' },
    { value: 'antiepileptics', label: 'ANTIEPILEPTICS' },
    { value: 'anti-parkinson_drugs', label: 'ANTI-PARKINSON DRUGS' },
    { value: 'psycholeptics', label: 'PSYCHOLEPTICS' },
    { value: 'psychoanaleptics', label: 'PSYCHOANALEPTICS' },
    { value: 'other_nervous_system_drugs', label: 'OTHER NERVOUS SYSTEM DRUGS' },
    { value: 'antiprotozoals', label: 'ANTIPROTOZOALS' },
    { value: 'nasal_preparations', label: 'NASAL PREPARATIONS' },
    { value: 'throat_preparations', label: 'THROAT PREPARATIONS' },
    { value: 'drugs_for_obstructive_airway_diseases', label: 'DRUGS FOR OBSTRUCTIVE AIRWAY DISEASES' },
    { value: 'cough_and_cold_preparations', label: 'COUGH AND COLD PREPARATIONS' },
    { value: 'antihistamines_for_systemic_use', label: 'ANTIHISTAMINES FOR SYSTEMIC USE' },
    { value: 'ophthalmologicals', label: 'OPHTHALMOLOGICALS' },
    { value: 'all_other_therapeutic_products', label: 'ALL OTHER THERAPEUTIC PRODUCTS' },
    { value: 'other_hematological_agents', label: 'OTHER HEMATOLOGICAL AGENTS' },
    { value: 'antihypertensives', label: 'ANTIHYPERTENSIVES' },
    { value: 'emollients_and_protectives', label: 'EMOLLIENTS AND PROTECTIVES' },
    { value: 'ectoparasiticides_incl_scabicides,_insecticides_and_repellents', label: 'ECTOPARASITICIDES, INCL. SCABICIDES, INSECTICIDES AND REPELLENTS' },
    { value: 'other_respiratory_system_products', label: 'OTHER RESPIRATORY SYSTEM PRODUCTS' },
    { value: 'stomatological_preparations', label: 'STOMATOLOGICAL PREPARATIONS' },
    { value: 'digestives_incl_enzymes', label: 'DIGESTIVES, INCL. ENZYMES' },
    { value: 'mineral_supplements', label: 'MINERAL SUPPLEMENTS' },
    { value: 'other_alimentary_tract_and_metabolism_products', label: 'OTHER ALIMENTARY TRACT AND METABOLISM PRODUCTS' },
    { value: 'antifungals_for_dermatological_use', label: 'ANTIFUNGALS FOR DERMATOLOGICAL USE' },
    { value: 'preparations_for_treatment_of_wounds_and_ulcers', label: 'PREPARATIONS FOR TREATMENT OF WOUNDS AND ULCERS' },
    { value: 'thyroid_therapy', label: 'THYROID THERAPY' },
    { value: 'calcium_homeostasis', label: 'CALCIUM HOMEOSTASIS' },
    { value: 'immune_sera_and_immunoglobulins', label: 'IMMUNE SERA AND IMMUNOGLOBULINS' },
    { value: 'immunosuppressants', label: 'IMMUNOSUPPRESSANTS' },
    { value: 'otologicals', label: 'OTOLOGICALS' },
    { value: 'contrast_media', label: 'CONTRAST MEDIA' },
    { value: 'anabolic_agents_for_systemic_use', label: 'ANABOLIC AGENTS FOR SYSTEMIC USE' },
    { value: 'appetite_stimulants', label: 'APPETITE STIMULANTS' },
    { value: 'pituitary_and_hypothalamic_hormones_and_analogues', label: 'PITUITARY AND HYPOTHALAMIC HORMONES AND ANALOGUES' },
    { value: 'topical_products_for_joint_and_muscular_pain', label: 'TOPICAL PRODUCTS FOR JOINT AND MUSCULAR PAIN' },
    { value: 'diagnostic_radiopharmaceuticals', label: 'DIAGNOSTIC RADIOPHARMACEUTICALS' },
    { value: 'anthelmintics', label: 'ANTHELMINTICS' },
    { value: 'pancreatic_hormones', label: 'PANCREATIC HORMONES' },
    { value: 'immunostimulants', label: 'IMMUNOSTIMULANTS' },
    { value: 'ophthalmological_and_otological_preparations', label: 'OPHTHALMOLOGICAL AND OTOLOGICAL PREPARATIONS' },
    { value: 'diagnostic_agents', label: 'DIAGNOSTIC AGENTS' },
    { value: 'therapeutic_radiopharmaceuticals', label: 'THERAPEUTIC RADIOPHARMACEUTICALS' },
    { value: 'other_drugs_for_disorders_of_the_musculo-skeletal_system', label: 'OTHER DRUGS FOR DISORDERS OF THE MUSCULO-SKELETAL SYSTEM' },
    { value: 'tonics', label: 'TONICS' },
    { value: 'all_other_non-therapeutic_products', label: 'ALL OTHER NON-THERAPEUTIC PRODUCTS' }
]
export const optionsList = [
    { value: 'Infant', label: 'Infant' },
    { value: 'Child', label: 'Child' },
    { value: 'Teen', label: 'Teen' },
    { value: 'Young Adult', label: 'Young Adult' },
    { value: 'Adult Female', label: 'Adult Female' },
    { value: 'Adult Male', label: 'Adult Male' },
    { value: 'Elderly Female', label: 'Elderly Female' },
    { value: 'Elderly Male', label: 'Elderly Male' },
]